import { render, staticRenderFns } from "./CsServicioDetalleFirmas.vue?vue&type=template&id=00f83008"
import script from "./CsServicioDetalleFirmas.vue?vue&type=script&lang=js"
export * from "./CsServicioDetalleFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports